import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../objects/user';
import { Load, LoadingSpaceType, LoadWithTranslatedName } from '../types';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public user: Observable<User>;
  private userSubject: BehaviorSubject<User>;

  constructor() {
    this.userSubject = new BehaviorSubject(new User());
    this.user = this.userSubject.asObservable();
  }

  public getState(): User {
    return this.userSubject.getValue();
  }

  public setState(user: User | null): void {
    if (!user) {
      this.userSubject.next(new User());
      return;
    }
    this.userSubject.next(user);
  }

  public sortLoadsByVolume(loadingSpaces: Load[]) {
    return loadingSpaces?.sort(
      (a, b) => a.length * a.width * a.height - b.length * b.width * b.height,
    );
  }

  public sortByTranslatedName(list: LoadWithTranslatedName[] | LoadingSpaceType[]) {
    return list.sort(
      (
        a: LoadWithTranslatedName | LoadingSpaceType,
        b: LoadWithTranslatedName | LoadingSpaceType,
      ) => {
        const textA = a.translatedName.toLowerCase();
        const textB = b.translatedName.toLowerCase();
        return textA.localeCompare(textB);
      },
    );
  }
}
